{
  "close": "Lukk",
  "notifications": "Varsler"
}
